import { PIANO, GUITAR, VOCAL, SYNTH } from './questions.js'
import { PiPianoKeysDuotone } from "react-icons/pi";
import { PiGuitar } from "react-icons/pi";
import { PiMicrophoneStageLight } from "react-icons/pi";
import { GiGrandPiano } from "react-icons/gi";
import { LiaDrumSolid } from "react-icons/lia";
import { IoIosMusicalNotes } from "react-icons/io";


export const DEFAULT = {
    DEFAULT_SETTINGS: {
        volume: 0.2,
        playStatus: false,
    },

    DEFAULT_FILTER: [
        { processorType: 'eq', type: 'peaking', frequency: 50, gain: 0, Q: 1, detune: 0, bypass: false },
        { processorType: 'eq', type: 'peaking', frequency: 100, gain: 0, Q: 1, detune: 0, bypass: false },
        { processorType: 'eq', type: 'peaking', frequency: 200, gain: 0, Q: 1, detune: 0, bypass: false },
        { processorType: 'eq', type: 'peaking', frequency: 500, gain: 0, Q: 1, detune: 0, bypass: false },
        { processorType: 'eq', type: 'peaking', frequency: 1000, gain: 0, Q: 1, detune: 0, bypass: false },
        { processorType: 'eq', type: 'peaking', frequency: 2000, gain: 0, Q: 1, detune: 0, bypass: false },
        { processorType: 'eq', type: 'peaking', frequency: 5000, gain: 0, Q: 1, detune: 0, bypass: false },
        { processorType: 'eq', type: 'peaking', frequency: 10000, gain: 0, Q: 1, detune: 0, bypass: false },
    ]
}

export const questions = {
    piano: {
        id: 1,
        icon: <GiGrandPiano />,
        title: 'Piano',
        list: PIANO
    },

    guitar: {
        id: 2,
        icon: <PiGuitar />,
        title: 'Guitar',
        list: GUITAR
    },

    vocal: {
        id: 3,
        icon: <PiMicrophoneStageLight />,
        title: 'Vocal',
        list: VOCAL
    },

    synth: {
        id: 4,
        icon: <PiPianoKeysDuotone />,
        title: 'Synth',
        list: SYNTH
    },

    percussion: {
        id: 5,
        icon: <LiaDrumSolid />,
        title: 'Percussion',
        list: SYNTH
    },

    track: {
        id: 6,
        icon: <IoIosMusicalNotes />,
        title: 'Track',
        list: SYNTH
    },

    //TODO add bass but multi track involved
}

